import { ComponentPublicInstance, Plugin } from 'vue';
import { Router } from 'vue-router';
import { errorRoute } from '~app/core/error/routes';
import { createError, errorHandler } from '~app/core/error/index';
import { hasOwn } from '~app/shared/json-mapper/utils';
import { App } from 'vue';

export interface ErrorPluginOptions {
  router: Router;
}

export const createErrorPlugin = ({
  router,
}: ErrorPluginOptions): Plugin<void> & { listen: (vm: ComponentPublicInstance) => void } => {
  return {
    install(app: App) {
      app.config.errorHandler = errorHandler;
      router.addRoute(errorRoute);
      router.addRoute({
        path: '/:catchAll(.*)*',
        component: () => import(/* webpackChunkName: 'error' */ './error.vue'),
      });

      router.onError((err) => {
        const { code, name, message } = createError(err);
        const errorParams: Record<string, string> = { code, name, message };
        const routeParams = router.currentRoute.value.params;

        if (
          router.currentRoute.value.name === errorRoute.name &&
          Object.keys(errorParams).every(
            (it) => hasOwn(routeParams, it) && routeParams[it] === errorParams[it],
          )
        ) {
          return Promise.resolve();
        }

        return router.replace({ name: errorRoute.name, params: errorParams });
      });
    },
    listen() {
      // handle errors outside Vue
      window.addEventListener('error', (e) => {
        e.preventDefault();
        errorHandler(e.error);
      });

      // handle unhandled rejections not captured by Vue (e.g. no `return` in lifecycle hook / event binding)
      window.addEventListener('unhandledrejection', (e) => {
        e.preventDefault();
        e.promise.catch((err) => (err ? errorHandler(err) : null));
      });
    },
  };
};
